import { Box } from '@mui/material';
import { unload as removePlaceholder } from './Placeholder';
import aaLogo from '../assets/images/aa-logo.svg';
import aaText from '../assets/images/aa-text.svg';

export function Header() {
  removePlaceholder();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 3,
        py: 2,
        mb: { xs: 0, sm: 4 },
        minHeight: '56px',
        width: '100vw',
        position: 'relative',
        left: '50%',
        ml: '-50vw',
      }}
    >
      <Box
        component="img"
        src={aaLogo}
        alt=""
        sx={{ height: { xs: 24, sm: 36 } }}
      />
      <Box
        component="img"
        src={aaText}
        alt="Advanced Agrilytics"
        sx={{ height: { xs: 9, sm: 14 }, ml: 1 }}
      />
    </Box>
  );
}
